import React, { useState } from 'react';
import PropTypes from 'prop-types';
import logo from 'core/assets/svg/branch-logo.svg';
import useStyles from './collect-email-screen.styles.js';

const emailRegex =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const CollectEmail = ({ email, onChange, onSubmit }) => {
  const [error, setError] = useState('');
  const classes = useStyles({ error });

  return (
    <div className={classes.widget}>
      <img src={logo} alt="gobranch" className={classes.logo} />
      <h1>Welcome to Staff</h1>
      <h3>Branch&rsquo;s sales and member servicing tool.</h3>
      <form className={classes.form}>
        {}
        <label htmlFor="email">Work or SSO email</label>
        <input
          id="email"
          name="email"
          type="email"
          placeholder="Enter your work or SSO email"
          value={email}
          onChange={onChange}
          autoFocus
        />
        <button
          onClick={(e) => {
            e.preventDefault();

            if (!emailRegex.test(email)) {
              setError('Please enter a valid email address');
              return;
            }

            setError('');
            onSubmit();
          }}
        >
          Sign In
        </button>
      </form>
      <div className={classes.footer}>
        <span>Don't have an account?</span>
        <p>Contact your agency&rsquo;s licensing contact or Branch supervisor.</p>
        {error && <p className={classes.error}>{error}</p>}
      </div>
    </div>
  );
};

CollectEmail.propTypes = {
  email: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default CollectEmail;
